module.exports = __webpack_public_path__ + "static/media/29BDOS18.6d0cc52b.jpg";